import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import dayjs from 'dayjs';
import axios from 'axios';
export default {
  name: 'only_goods_page',
  components: {
    sourceBatchSel: function sourceBatchSel() {
      return import('./source_batch_sel.vue');
    }
  },
  props: {
    current: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '一物一码',
        addFunName: 'sourceUniqueDetailAdd',
        cancelFunName: 'sourceUniqueDetailCancel',
        useFunName: 'sourceUniqueDetailUse',
        queryFunName: 'sourceUniqueDetailQuery',
        detailFunName: 'sourceUniqueDetailDetail',
        delFunName: 'sourceUniqueDetailDel',
        delBatchFunName: 'sourceUniqueDetailBatchDel',
        useBatchFunName: 'sourceUniqueDetailBatchUse',
        cancelBatchFunName: 'sourceUniqueDetailBatchCancel'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'create_time',
        uniqueBatchId: this.current.id,
        sourceBatchId: this.current.sourceBatchId
      },
      formData: {
        limitScan: 'No_Limit',
        uniqueBatchId: this.current.id
      },
      rules: {
        scanAmount: [{
          required: true,
          message: '请输入扫描次数',
          trigger: 'blur'
        }],
        sourceBatchId: [{
          required: true,
          message: '请选择溯源批次',
          trigger: 'blur'
        }],
        validTime: [{
          required: true,
          message: '请选择有效期截止',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      detailDialogShow: false,
      detailData: {},
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {},
      batch_show: false,
      multipleSelection: []
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  methods: {
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (!this.formData.limitScan) {
        this.$set(this.formData, 'limitScan', 'No_Limit');
      }
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    back: function back() {
      this.$emit('child-go-batch');
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    beforeCommand: function beforeCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command
      };
    },
    moreButton: function moreButton(command) {
      switch (command.command) {
        case 'download':
          // 下载
          this.download(command.row.id);
          break;
        case 'cancel':
          // 作废
          this.cancel(command.row.id);
          break;
        case 'use':
          // 使用
          this.use(command.row.id);
          break;
        case 'del':
          // 删除
          this.del(command.row.id);
          break;
      }
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    detail: function detail(data) {
      this.detailData = data;
      this.$set(this.detailData, 'createTime', dayjs(data.createTime).format('YYYY-MM-DD HH:mm:ss'));
      this.$set(this.detailData, 'validTime', dayjs(data.validTime).format('YYYY-MM-DD HH:mm:ss'));
      this.detailDialogShow = true;
    },
    cancel: function cancel(id) {
      var _this = this;
      this.$confirm('确定要作废吗').then(function () {
        _this.$api[_this.pageConfig.cancelFunName](id).then(function (res) {
          if (res.data) {
            _this.$message.success('已作废');
            _this.query();
          } else {
            _this.$message.error('作废失败');
          }
        });
      });
    },
    use: function use(id) {
      var _this2 = this;
      this.$confirm('确定要使用吗').then(function () {
        _this2.$api[_this2.pageConfig.useFunName](id).then(function (res) {
          if (res.data) {
            _this2.$message.success('已使用');
            _this2.query();
          } else {
            _this2.$message.error('使用失败');
          }
        });
      });
    },
    download: function download(id) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, blob, url, link;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return axios({
                url: "".concat(process.env.VUE_APP_API, "/wechat/applet/minicode/").concat(id),
                method: 'GET',
                params: {
                  page: "src/pagesA/source/oneCode"
                },
                headers: {
                  'Content-Type': 'application/json;charset=UTF-8',
                  'Authorization': localStorage.getItem('token')
                },
                responseType: 'blob' // 关键！
              });
            case 3:
              res = _context.sent;
              // 创建 Blob URL
              blob = new Blob([res.data], {
                type: 'image/png'
              }); // 根据实际格式调整
              url = window.URL.createObjectURL(blob); // 创建下载链接
              link = document.createElement('a');
              link.href = url;
              link.download = "\u4E00\u7269\u4E00\u7801_".concat(Date.now(), ".png"); // 自定义文件名
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              // 释放内存
              window.URL.revokeObjectURL(url);
              _context.next = 18;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](0);
              console.error('加载图片失败', _context.t0);
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 15]]);
      }))();
    } // 批量选择
    ,
    handleSelectionChange: function handleSelectionChange(val) {
      // console.log('handleSelectionChange',val)
      this.multipleSelection = val;
    } // 批量删除
    ,
    deletionBatch: function deletionBatch() {
      var _this3 = this;
      if (!this.multipleSelection.length) {
        this.$message.info('请先选择操作数据！');
        return;
      }
      var ids = [];
      var _iterator = _createForOfIteratorHelper(this.multipleSelection),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          ids.push(item.id);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.$confirm('确定要批量删除吗').then(function () {
        _this3.$api[_this3.pageConfig.delBatchFunName](ids).then(function (res) {
          if (res.data) {
            _this3.$message.success('删除成功');
            _this3.query();
          } else {
            _this3.$message.error('删除失败');
          }
        });
      });
    } // 批量使用
    ,
    useBatch: function useBatch() {
      var _this4 = this;
      if (!this.multipleSelection.length) {
        this.$message.info('请先选择操作数据！');
        return;
      }
      var ids = [];
      var _iterator2 = _createForOfIteratorHelper(this.multipleSelection),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          ids.push(item.id);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.$confirm('确定要批量使用吗').then(function () {
        _this4.$api[_this4.pageConfig.useBatchFunName](ids).then(function (res) {
          if (res.data) {
            _this4.$message.success('使用成功');
            _this4.query();
          } else {
            _this4.$message.error('使用失败');
          }
        });
      });
    } // 批量作废
    ,
    cancelBatch: function cancelBatch() {
      var _this5 = this;
      if (!this.multipleSelection.length) {
        this.$message.info('请先选择操作数据！');
        return;
      }
      var ids = [];
      var _iterator3 = _createForOfIteratorHelper(this.multipleSelection),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;
          ids.push(item.id);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      this.$confirm('确定要批量作废吗').then(function () {
        _this5.$api[_this5.pageConfig.cancelBatchFunName](ids).then(function (res) {
          if (res.data) {
            _this5.$message.success('作废成功');
            _this5.query();
          } else {
            _this5.$message.error('作废失败');
          }
        });
      });
    },
    sourceBatchSel: function sourceBatchSel(val) {
      if (val) {
        this.$set(this.formData, 'sourceBatchId', val.id);
        this.$set(this.formData, 'productName', val.productName);
      }
      this.batch_show = false;
    },
    del: function del(id) {
      var _this6 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this6.$api[_this6.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this6.$message.success('删除成功');
            _this6.query();
          } else {
            _this6.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this7 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this7.tableData = res.data || [];
        _this7.totalCount = res.count;
        _this7.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this8 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          _this8.formData.uniqueBatchId = _this8.current.id;
          _this8.$api[_this8.pageConfig.addFunName](_this8.saveFormDataProcess(_this8.formData)).then(function (res) {
            if (res.data) {
              _this8.$message.success('新增成功');
              _this8.initFormData(_this8.emptyFormData);
              _this8.editDialogShow = false;
              _this8.query();
            } else {
              _this8.$message.error('新增失败');
            }
          });
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};